import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import React from "react";
import HomePage from "./view/Home";
import Book from "./view/Book";
import Header from "./components/layout/Header";
import CommonFooter from "./components/layout/Footer";
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/book" element={<Book />} />
        </Routes>
        <CommonFooter />
      </BrowserRouter>
    </div>
  );
}

export default App;
